import { Box, Card, Flex } from '@chakra-ui/react'
import type { InsuranceParamsVehiclePagedQuery } from 'BrokerTsLib/src/dtos'
import { useSearchParamsStatePersistance } from 'BrokerTsLib/src/hooks/useSearchParamsStatePersistance'
import { createContext, useEffect, useState } from 'react'

import { ContractsExportForm } from '@/containers/export/ContractsExportForm'

import { ExportButton } from '@/containers/export/ExportButton'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import type { IPaginationContext } from 'BrokerTsLib/src/interfaces/Pagination/Pagination'
import { ContractsList } from '../../containers/contracts/ContractsList'
import { DashboardHeader } from '../../containers/dashboard/DashboardHeader'
import { PageToolbar } from '../../containers/PageToolbar'
import { ContractsCarSearch } from '../../containers/search/ContractsCarSearch'
import { SearchButton } from '../../containers/search/SearchButton'
import { WithAuth } from '../../hoc/WithAuth'
import { useGetAll } from '../../hooks/useInsuranceParams'
import { PageWrapper } from '../../layouts/components/PageWrapper'

export const contractsCarsContext = createContext<
  IPaginationContext<InsuranceParamsVehiclePagedQuery>
>({} as IPaginationContext<InsuranceParamsVehiclePagedQuery>)

const ContractsCarPageComponent = () => {
  const { translate } = useTranslationsContext()
  const [filter, setFilter, searchParams] =
    useSearchParamsStatePersistance<InsuranceParamsVehiclePagedQuery>(
      {
        listType: 2,
        pageIndex: 1,
        pageSize: 10,
      },
      ['listType'],
    )

  const [isSearchOpen, setSearchOpen] = useState(searchParams.size > 2)
  const [isExportOpen, setExportOpen] = useState(false)

  const { data, mutateAsync: getAllAsync, isPending } = useGetAll()
  const items = data?.data

  useEffect(() => {
    if (filter.pageSize)
      // nechci spoustet nacitani na pageload 2x
      getAllAsync(filter)
  }, [filter])

  return (
    <PageWrapper
      header={<DashboardHeader title={translate('ui.contracts', 'Smlouvy')} />}
      mainProps={{
        sx: { pt: { base: 0, md: 8 }, gap: 4, display: 'grid', alignContent: 'start' },
      }}
    >
      <PageToolbar
        rightElements={
          <Flex sx={{ gap: 4 }}>
            <ExportButton isExportOpen={isExportOpen} setExportOpen={setExportOpen} />
            <SearchButton isOpen={isSearchOpen} toggleOpen={() => setSearchOpen(!isSearchOpen)} />
          </Flex>
        }
      />

      <contractsCarsContext.Provider
        value={{
          loading: isPending,
          totalCount: items?.totalCount ?? 0,
          currentPage: filter.pageIndex,
          pageSize: filter.pageSize ?? 10,
          filter: filter,
          setCurrentPage: (p: number) => setFilter({ ...filter, pageIndex: p }),
          setPageSize: (s: number) => setFilter({ ...filter, pageSize: s }),
          updateFilter: setFilter,
          reload: () => { },
        }}
      >
        {isSearchOpen && <ContractsCarSearch />}
        {isExportOpen && <ContractsExportForm />}

        <Card>
          <Box
            sx={{
              display: 'grid',
              gap: 8,
              placeItems: 'start',
              justifyItems: 'stretch',
            }}
          >
            <ContractsList contracts={items?.items ?? []} withPaginator />
          </Box>
        </Card>
      </contractsCarsContext.Provider>
    </PageWrapper>
  )
}

export const ContractsCarPage = WithAuth(ContractsCarPageComponent)
